import BrokenImageOutlined from '@mui/icons-material/BrokenImageOutlined';
import { Box, useTheme } from '@mui/material';
import { DefaultComponentProps } from '@mui/material/OverridableComponent';
import { BoxTypeMap } from '@mui/system';

export interface PlaceholderProperties
  extends Omit<DefaultComponentProps<BoxTypeMap<Record<string, unknown>, 'div'>>, 'color'> {
  readonly color?: string;
  readonly size?: number;
}

export function Placeholder({ color, size = 300, ...properties }: PlaceholderProperties) {
  const theme = useTheme();
  const resolvedColor = color ?? theme.palette.text.disabled;

  return (
    <Box
      width={size}
      height={size}
      maxWidth='100%'
      justifyContent='center'
      alignItems='center'
      display='flex'
      flexDirection='column'
      gap={1}
      {...properties}
    >
      <BrokenImageOutlined
        sx={{
          fontSize: size * 0.5,
          color: resolvedColor,
        }}
      />
    </Box>
  );
}
